export default {
  setSelectedTopic: (state, topic) => {
    state.selectedTopic = topic;
  },
};
